if (!customElements.get('marquee-content')) {
class UKMarquee extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    calculationPaddingSection() {
      (this.heightSection = this.offsetHeight),
        (this.heightSection =
          this.heightSection < 18
            ? 18
            : 96 < this.heightSection
            ? 96
            : this.heightSection),
        this.closest(".js-running-content").style.setProperty(
          "--spacing-padding-block",
          this.heightSection + "px"
        );
    }
    init() {
      (this.distance = this.querySelector(".js-marquee-item").offsetWidth),
        (this.speed = this.dataset.speed),
        this.style.setProperty(
          "--marquee-duration",
          this.distance / this.speed + "s"
        );
    }
}
customElements.define("marquee-content", UKMarquee);
}

class slideshowSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sliderWrapper = this.querySelector(".slideshow__swiper");
    if (!this.sliderWrapper) return;
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this.sliderWrapper);
    //  console.log("testdd",this.sliderWrapper.dataset)
  }
  init() {
    let centered_slides =
      this.sliderWrapper.dataset.centeredslides !== undefined ? JSON.parse(this.sliderWrapper.dataset.centeredslides) : undefined;
    let effect_fade =
      this.sliderWrapper.dataset.effectfade !== undefined
        ? JSON.parse(this.sliderWrapper.dataset.effectfade)
        : undefined;
    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");

    // console.log("Tress", centered_slides);

    const slider = new Swiper(this.sliderWrapper, {
      effect: effect_fade ? "fade" : "slide",
      centeredSlides: centered_slides ? centered_slides : false,
      slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
      spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
      grabCursor: true,
      horizontal: true,
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
      loop: JSON.parse(this.sliderWrapper.dataset.loop),
      speed: 700,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
        disableOnInteraction: false,
        delay: parseInt(this.sliderWrapper.dataset.delay)
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      breakpoints: {
        359: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
          spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
        },
        768: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
          spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
        },
        1024: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
          spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
        },
      },
    });

    return slider;
  }
}
customElements.define("slideshow-swiper", slideshowSwiper);




// const swiper = new Swiper('.testimonial-slider', {
//   loop: true,
//   slidesPerView: 'auto',
//   autoplay: {
//     delay: 5000,
//     disableOnInteraction: true
//   },
//   centeredSlides: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   }
// });




class AutoSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sliderWrapper = this.querySelector(".slideshow__swiper");
    if (!this.sliderWrapper) return;
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this.sliderWrapper);
    //  console.log("testdd",this.sliderWrapper.dataset)
  }
  init() {
    let centered_slides =
      this.sliderWrapper.dataset.centeredslides !== undefined ? JSON.parse(this.sliderWrapper.dataset.centeredslides) : undefined;
    let effect_fade =
      this.sliderWrapper.dataset.effectfade !== undefined
        ? JSON.parse(this.sliderWrapper.dataset.effectfade)
        : undefined;
    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");

    // console.log("Tress", centered_slides);

    const slider = new Swiper(this.sliderWrapper, {
      effect: effect_fade ? "fade" : "slide",
      centeredSlides: centered_slides ? centered_slides : false,
      slidesPerView: 'auto',
      grabCursor: true,
      horizontal: true,
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
      loop: JSON.parse(this.sliderWrapper.dataset.loop),
      speed: 700,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
        disableOnInteraction: false,
        delay: parseInt(this.sliderWrapper.dataset.delay)
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        clickable: true,
      }
    });

    return slider;
  }
}
customElements.define("auto-swiper", AutoSwiper);

$('.buy-now').removeClass("loading");

$('.buy-now').on("click", function (e) {
  e.preventDefault();
  var form = $(this).closest("form");
  $(this).addClass("loading");
  var formParams = form.serialize();
   $.ajax({
    url: "/cart/add",
    type: "post",
    data: formParams,
    success: function(){
      $(this).removeClass("loading");
      window.location.href = "/checkout";
    },
    error: function(){
    }
   })

});
